import React from 'react';
import { MessageSquare, ChevronRight } from 'lucide-react';
import { Card } from '../../../../components/ui/card';
import { useNavigate } from 'react-router-dom';

export function ForumWidget() {
  const navigate = useNavigate();

  return (
    <Card className="p-4">
      <button
        onClick={() => navigate('/forum')}
        className="w-full flex items-center justify-between text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50 rounded-lg transition-colors"
      >
        <div className="flex items-center gap-2">
          <MessageSquare className="h-5 w-5 text-gray-500" />
          <span className="font-medium">Foro</span>
        </div>
        <ChevronRight className="h-5 w-5 text-gray-400" />
      </button>
    </Card>
  );
} 